export const APERTURA = '00'
export const ENERO = '01'
export const FEBRERO = '02'
export const MARZO = '03'
export const ABRIL = '04'
export const MAYO = '05'
export const JUNIO = '06'
export const JULIO = '07'
export const AGOSTO = '08'
export const SEPTIEMBRE = '09'
export const OCTUBRE = '10'
export const NOVIEMBRE = '11'
export const DICIEMBRE = '12'
export const MES13 = '13'
export const MES14 = '14'
export const MES15 = '15'

export const __dictionary = {
  [APERTURA]: {
    id: APERTURA,
    nombre: 'APERTURA',
    nombreCorto: 'APE'
  },
  [ENERO]: {
    id: ENERO,
    nombre: 'ENERO',
    nombreCorto: 'ENE'
  },
  [FEBRERO]: {
    id: FEBRERO,
    nombre: 'FEBRERO',
    nombreCorto: 'FEB'
  },
  [MARZO]: {
    id: MARZO,
    nombre: 'MARZO',
    nombreCorto: 'MAR'
  },
  [ABRIL]: {
    id: ABRIL,
    nombre: 'ABRIL',
    nombreCorto: 'ABR'
  },
  [MAYO]: {
    id: MAYO,
    nombre: 'MAYO',
    nombreCorto: 'MAY'
  },
  [JUNIO]: {
    id: JUNIO,
    nombre: 'JUNIO',
    nombreCorto: 'JUN'
  },
  [JULIO]: {
    id: JULIO,
    nombre: 'JULIO',
    nombreCorto: 'JUL'
  },
  [AGOSTO]: {
    id: AGOSTO,
    nombre: 'AGOSTO',
    nombreCorto: 'AGO'
  },
  [SEPTIEMBRE]: {
    id: SEPTIEMBRE,
    nombre: 'SEPTIEMBRE',
    nombreCorto: 'SEP'
  },
  [OCTUBRE]: {
    id: OCTUBRE,
    nombre: 'OCTUBRE',
    nombreCorto: 'OCT'
  },
  [NOVIEMBRE]: {
    id: NOVIEMBRE,
    nombre: 'NOVIEMBRE',
    nombreCorto: 'NOV'
  },
  [DICIEMBRE]: {
    id: DICIEMBRE,
    nombre: 'DICIEMBRE',
    nombreCorto: 'DIC'
  },
  [MES13]: {
    id: MES13,
    nombre: 'AJUSTES',
    nombreCorto: 'MES13'
  },
  [MES14]: {
    id: MES14,
    nombre: 'CIERRE CLASE 6, 7, 9',
    nombreCorto: 'MES14'
  },
  [MES15]: {
    id: MES15,
    nombre: 'CIERRE ACTIVOS, PASIVOS Y PATRIMONIOS',
    nombreCorto: 'MES15'
  }
}

export const __array = [
  __dictionary[APERTURA],
  __dictionary[ENERO],
  __dictionary[FEBRERO],
  __dictionary[MARZO],
  __dictionary[ABRIL],
  __dictionary[MAYO],
  __dictionary[JUNIO],
  __dictionary[JULIO],
  __dictionary[AGOSTO],
  __dictionary[SEPTIEMBRE],
  __dictionary[OCTUBRE],
  __dictionary[NOVIEMBRE],
  __dictionary[DICIEMBRE],
  __dictionary[MES13],
  __dictionary[MES14],
  __dictionary[MES15]
]

export const __arrayEneDic = [
  __dictionary[ENERO],
  __dictionary[FEBRERO],
  __dictionary[MARZO],
  __dictionary[ABRIL],
  __dictionary[MAYO],
  __dictionary[JUNIO],
  __dictionary[JULIO],
  __dictionary[AGOSTO],
  __dictionary[SEPTIEMBRE],
  __dictionary[OCTUBRE],
  __dictionary[NOVIEMBRE],
  __dictionary[DICIEMBRE]
]
